module.exports = __webpack_public_path__ + "static/media/Sean Martinez Headshot copy_1674558734516.3b8d014c.png";